import { Link, useNavigate } from "react-router";
import { Button } from "../../../app/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../app/components/ui/card";
import { useBrands } from "../hooks/useBrands";
import { useCategories } from "../hooks/useCategories";
import { ProductForm } from "../components/ProductForm";

export function ProductCreatePage() {
  const navigate = useNavigate();
  const { brands, loading: brandsLoading, error: brandsError } = useBrands();
  const { categories, loading: categoriesLoading, error: categoriesError } = useCategories();

  const loading = brandsLoading || categoriesLoading;
  const error = brandsError || categoriesError;

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-1">Create product</h1>
          <p className="text-muted-foreground">Add a new product to your catalog.</p>
        </div>
        <Button asChild variant="outline">
          <Link to="/products">Back</Link>
        </Button>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>Product details</CardTitle>
          <CardDescription>Name, brand, and categories</CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="text-muted-foreground">Loading...</div>
          ) : error ? (
            <div className="text-destructive text-sm">{error}</div>
          ) : (
            <ProductForm
              brands={brands}
              categories={categories}
              onSuccess={() => navigate("/products")}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}

